<template>
    <div v-if="isLoadingUser" style="display: flex;align-items: center;justify-content: center;height:100vh">
        <Spinner />
    </div>
    <div v-else class="container">
        <div class="colorHalf">
            <svg class="logo" width="556px" height="375px" viewBox="0 0 556 375" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Brand-concepts---final-more-intense-red-v5-Copy" transform="translate(-948.000000, -956.000000)">
                        <g id="Group-3" transform="translate(908, 880)">
                            <g id="Group-2" transform="translate(303.957741, 266.840746) rotate(-12.000000) translate(-303.957741, -266.840746) translate(81.457741, 41.840746)">
                                <g id="Group-2-Copy-4" transform="translate(222.578890, 225.247019) rotate(50.000000) translate(-222.578890, -225.247019) translate(53.578890, 77.747019)">
                                    <g id="Group-Copy-4" transform="translate(106.231196, 98.616671) scale(-1, 1) rotate(70.000000) translate(-106.231196, -98.616671) translate(32.231196, 16.116671)">
                                        <g id="Oval-2-Copy-3" transform="translate(76.261319, 82.332441) rotate(33.000000) translate(-76.261319, -82.332441) ">
                                            <path fill="#ffffff" stroke="#000000" stroke-width="15" d="M77.7637304,163.14924 C65.1293912,163.14924 50.4428118,152.219197 42.0636381,136.575113 C34.8113748,123.034994 31.0602551,103.514005 31.0093699,86.4050311 C30.9796812,76.4228959 31.6417683,50.9206132 32.9968796,9.73611573 C33.072169,7.44792302 34.0673236,5.28685118 35.7570703,3.74210186 C39.2218517,0.574633808 44.5983521,0.815653884 47.7658196,4.28043466 C69.9493414,28.5461999 84.0757619,44.0076924 90.146136,50.6660712 C110.146347,72.6035959 120.703765,93.477381 121.45824,108.566887 C122.770103,134.804137 100.400177,163.14924 77.7637304,163.14924 Z"></path>
                                        </g>
                                    </g>
                                    <g id="Group-Copy-3" transform="translate(0.187780, 65.000000)">
                                        <g id="Oval-2-Copy-3" transform="translate(107.167615, 120.405165) scale(1, -1) rotate(-40.000000) translate(-107.167615, -120.405165) ">
                                            <path fill="#ffffff" stroke="#000000" stroke-width="15" d="M131.728863,212.736693 C117.066671,212.736693 99.7499693,199.84926 89.8435813,181.353837 C83.5989087,169.69491 64.3833688,122.811391 31.7360985,39.6809954 C30.9385149,37.6500924 30.9524607,35.3902501 31.7750487,33.3693455 C33.5448614,29.0213331 38.5043385,26.9312893 42.8523481,28.7011009 C103.620342,53.4360447 136.976737,69.5842562 145.565678,79.005162 C169.590013,105.356607 182.227484,130.343005 183.121472,148.222765 C184.669733,179.187979 158.193123,212.736693 131.728863,212.736693 Z"></path>
                                        </g>
                                    </g>
                                    <circle id="Oval-2-Copy-6" stroke="#000000" stroke-width="13" fill="#ffffff" cx="206" cy="165" r="50"></circle>
                                    <circle id="Oval-2-Copy-5" stroke="#000000" stroke-width="13" fill="#ffffff" cx="212.102508" cy="103.37638" r="40"></circle>
                                    <circle id="Oval-2-Copy-4" stroke="#000000" stroke-width="13" fill="#ffffff" cx="263.857699" cy="135.128356" r="32"></circle>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <path d="M29.162,368.966 C30.8020082,369.840671 31.622,370.933993 31.622,372.246 C31.622,372.628669 31.5946669,372.901999 31.54,373.066 C31.0479975,374.815342 29.9546751,375.69 28.26,375.69 C27.9866653,375.69 27.5766694,375.635334 27.03,375.526 C24.8433224,375.143331 23.0666735,374.952 21.7,374.952 C17.7639803,374.952 14.5933454,375.853991 12.188,377.658 C9.78265464,379.462009 8.58,381.894651 8.58,384.956 L8.58,408.9 C8.58,410.212007 8.23833675,411.22333 7.555,411.934 C6.87166325,412.64467 5.8466735,413 4.48,413 C3.16799344,413 2.15667022,412.658337 1.446,411.975 C0.73532978,411.291663 0.38,410.266674 0.38,408.9 L0.38,372.246 C0.38,370.933993 0.73532978,369.92267 1.446,369.212 C2.15667022,368.50133 3.16799344,368.146 4.48,368.146 C7.213347,368.146 8.58,369.512653 8.58,372.246 L8.58,373.804 C10.2200082,371.890657 12.2426546,370.387339 14.648,369.294 C17.0533454,368.200661 19.622653,367.654 22.356,367.654 C25.2533478,367.654 27.5219918,368.091329 29.162,368.966 Z M89.814666,392.459 C89.1039958,393.142337 88.2020048,393.484 87.108666,393.484 L55.948666,393.484 C56.5500024,397.310686 58.2856517,400.399322 61.155666,402.75 C64.0256804,405.100678 67.5379786,406.276 71.692666,406.276 C73.3326742,406.276 75.0409905,405.975336 76.817666,405.374 C78.5943416,404.772664 80.0566603,404.034671 81.204666,403.16 C81.9700032,402.558664 82.8719942,402.258 83.910666,402.258 C84.9493379,402.258 85.7693297,402.531331 86.370666,403.078 C87.354671,403.898004 87.846666,404.827328 87.846666,405.866 C87.846666,406.850005 87.4093371,407.669997 86.534666,408.326 C84.6759901,409.802007 82.3663465,411.004662 79.605666,411.934 C76.8449856,412.863338 74.2073453,413.328 71.692666,413.328 C67.209977,413.328 63.1920171,412.357676 59.638666,410.417 C56.0853149,408.476324 53.3110093,405.784017 51.315666,402.34 C49.3203227,398.895983 48.322666,394.987355 48.322666,390.614 C48.322666,386.240645 49.2656566,382.318351 51.151666,378.847 C53.0376755,375.375649 55.6616492,372.669676 59.023666,370.729 C62.3856828,368.788324 66.1986447,367.818 70.462666,367.818 C74.6720204,367.818 78.3073174,368.747324 81.368666,370.606 C84.4300147,372.464676 86.7806578,375.061317 88.420666,378.396 C90.0606742,381.730683 90.880666,385.557312 90.880666,389.876 C90.880666,390.914672 90.5253363,391.775663 89.814666,392.459 Z M60.745666,378.15 C58.2583203,380.336678 56.6866693,383.261315 56.030666,386.924 L83.336666,386.924 C82.8446636,383.261315 81.4780106,380.336678 79.236666,378.15 C76.9953215,375.963322 74.0706841,374.87 70.462666,374.87 C66.4719794,374.87 63.2330118,375.963322 60.745666,378.15 Z M127.179332,359.536 C125.320656,361.558677 124.391332,364.237317 124.391332,367.572 L124.391332,369.786 L132.755332,369.786 C133.903338,369.786 134.832662,370.113997 135.543332,370.77 C136.254002,371.426003 136.609332,372.300661 136.609332,373.394 C136.609332,374.378005 136.254002,375.197997 135.543332,375.854 C134.832662,376.510003 133.903338,376.838 132.755332,376.838 L124.391332,376.838 L124.391332,408.818 C124.391332,410.07534 124.008669,411.086663 123.243332,411.852 C122.477995,412.617337 121.412006,413 120.045332,413 C118.951993,413 118.009003,412.617337 117.216332,411.852 C116.423661,411.086663 116.027332,410.07534 116.027332,408.818 L116.027332,376.838 L112.501332,376.838 C111.353326,376.838 110.424002,376.510003 109.713332,375.854 C109.002662,375.197997 108.647332,374.378005 108.647332,373.394 C108.647332,372.300661 109.002662,371.426003 109.713332,370.77 C110.424002,370.113997 111.353326,369.786 112.501332,369.786 L116.027332,369.786 L116.027332,368.392 C116.027332,364.510647 116.806324,361.107681 118.364332,358.183 C119.92234,355.258319 122.108985,352.989675 124.924332,351.377 C127.739679,349.764325 130.951314,348.958 134.559332,348.958 C135.762005,348.958 136.759661,349.31333 137.552332,350.024 C138.345003,350.73467 138.741332,351.636661 138.741332,352.73 C138.741332,353.823339 138.345003,354.72533 137.552332,355.436 C136.759661,356.14667 135.762005,356.502 134.559332,356.502 C131.497983,356.502 129.038008,357.513323 127.179332,359.536 Z M196.523998,392.459 C195.813328,393.142337 194.911337,393.484 193.817998,393.484 L162.657998,393.484 C163.259334,397.310686 164.994984,400.399322 167.864998,402.75 C170.735012,405.100678 174.247311,406.276 178.401998,406.276 C180.042006,406.276 181.750323,405.975336 183.526998,405.374 C185.303674,404.772664 186.765992,404.034671 187.913998,403.16 C188.679335,402.558664 189.581326,402.258 190.619998,402.258 C191.65867,402.258 192.478662,402.531331 193.079998,403.078 C194.064003,403.898004 194.555998,404.827328 194.555998,405.866 C194.555998,406.850005 194.118669,407.669997 193.243998,408.326 C191.385322,409.802007 189.075679,411.004662 186.314998,411.934 C183.554318,412.863338 180.916677,413.328 178.401998,413.328 C173.919309,413.328 169.901349,412.357676 166.347998,410.417 C162.794647,408.476324 160.020341,405.784017 158.024998,402.34 C156.029655,398.895983 155.031998,394.987355 155.031998,390.614 C155.031998,386.240645 155.974989,382.318351 157.860998,378.847 C159.747008,375.375649 162.370981,372.669676 165.732998,370.729 C169.095015,368.788324 172.907977,367.818 177.171998,367.818 C181.381352,367.818 185.016649,368.747324 188.077998,370.606 C191.139347,372.464676 193.48999,375.061317 195.129998,378.396 C196.770006,381.730683 197.589998,385.557312 197.589998,389.876 C197.589998,390.914672 197.234668,391.775663 196.523998,392.459 Z M167.454998,378.15 C164.967652,380.336678 163.396001,383.261315 162.739998,386.924 L190.045998,386.924 C189.553996,383.261315 188.187343,380.336678 185.945998,378.15 C183.704654,375.963322 180.780016,374.87 177.171998,374.87 C173.181311,374.87 169.942344,375.963322 167.454998,378.15 Z M250.698664,368.966 C252.338672,369.840671 253.158664,370.933993 253.158664,372.246 C253.158664,372.628669 253.131331,372.901999 253.076664,373.066 C252.584662,374.815342 251.491339,375.69 249.796664,375.69 C249.523329,375.69 249.113334,375.635334 248.566664,375.526 C246.379987,375.143331 244.603338,374.952 243.236664,374.952 C239.300644,374.952 236.130009,375.853991 233.724664,377.658 C231.319319,379.462009 230.116664,381.894651 230.116664,384.956 L230.116664,408.9 C230.116664,410.212007 229.775001,411.22333 229.091664,411.934 C228.408327,412.64467 227.383338,413 226.016664,413 C224.704658,413 223.693334,412.658337 222.982664,411.975 C222.271994,411.291663 221.916664,410.266674 221.916664,408.9 L221.916664,372.246 C221.916664,370.933993 222.271994,369.92267 222.982664,369.212 C223.693334,368.50133 224.704658,368.146 226.016664,368.146 C228.750011,368.146 230.116664,369.512653 230.116664,372.246 L230.116664,373.804 C231.756672,371.890657 233.779319,370.387339 236.184664,369.294 C238.590009,368.200661 241.159317,367.654 243.892664,367.654 C246.790012,367.654 249.058656,368.091329 250.698664,368.966 Z M310.32633,370.77 C313.524346,372.73801 316.038988,375.457649 317.87033,378.929 C319.701673,382.400351 320.61733,386.267979 320.61733,390.532 C320.61733,394.796021 319.63334,398.663649 317.66533,402.135 C315.69732,405.606351 312.977681,408.339657 309.50633,410.335 C306.034979,412.330343 302.194685,413.328 297.98533,413.328 C293.775976,413.328 289.963014,412.330343 286.54633,410.335 C283.129646,408.339657 280.423673,405.606351 278.42833,402.135 C276.432987,398.663649 275.43533,394.796021 275.43533,390.532 L275.43533,353.14 C275.43533,351.88266 275.83166,350.871337 276.62433,350.106 C277.417001,349.340663 278.414657,348.958 279.61733,348.958 C280.87467,348.958 281.885993,349.340663 282.65133,350.106 C283.416667,350.871337 283.79933,351.88266 283.79933,353.14 L283.79933,375.28 C285.712673,372.929322 288.035983,371.098007 290.76933,369.786 C293.502677,368.473993 296.454648,367.818 299.62533,367.818 C303.56135,367.818 307.128314,368.80199 310.32633,370.77 Z M305.40633,403.939 C307.620341,402.59966 309.369657,400.754678 310.65433,398.404 C311.939003,396.053322 312.58133,393.429348 312.58133,390.532 C312.58133,387.634652 311.939003,385.024345 310.65433,382.701 C309.369657,380.377655 307.620341,378.54634 305.40633,377.207 C303.192319,375.86766 300.718677,375.198 297.98533,375.198 C295.251983,375.198 292.778341,375.86766 290.56433,377.207 C288.350319,378.54634 286.61467,380.377655 285.35733,382.701 C284.099991,385.024345 283.47133,387.634652 283.47133,390.532 C283.47133,393.429348 284.099991,396.053322 285.35733,398.404 C286.61467,400.754678 288.350319,402.59966 290.56433,403.939 C292.778341,405.27834 295.251983,405.948 297.98533,405.948 C300.718677,405.948 303.192319,405.27834 305.40633,403.939 Z M385.943996,392.459 C385.233326,393.142337 384.331335,393.484 383.237996,393.484 L352.077996,393.484 C352.679333,397.310686 354.414982,400.399322 357.284996,402.75 C360.155011,405.100678 363.667309,406.276 367.821996,406.276 C369.462004,406.276 371.170321,405.975336 372.946996,405.374 C374.723672,404.772664 376.18599,404.034671 377.333996,403.16 C378.099333,402.558664 379.001324,402.258 380.039996,402.258 C381.078668,402.258 381.89866,402.531331 382.499996,403.078 C383.484001,403.898004 383.975996,404.827328 383.975996,405.866 C383.975996,406.850005 383.538667,407.669997 382.663996,408.326 C380.80532,409.802007 378.495677,411.004662 375.734996,411.934 C372.974316,412.863338 370.336675,413.328 367.821996,413.328 C363.339307,413.328 359.321347,412.357676 355.767996,410.417 C352.214645,408.476324 349.440339,405.784017 347.444996,402.34 C345.449653,398.895983 344.451996,394.987355 344.451996,390.614 C344.451996,386.240645 345.394987,382.318351 347.280996,378.847 C349.167006,375.375649 351.790979,372.669676 355.152996,370.729 C358.515013,368.788324 362.327975,367.818 366.591996,367.818 C370.801351,367.818 374.436648,368.747324 377.497996,370.606 C380.559345,372.464676 382.909988,375.061317 384.549996,378.396 C386.190004,381.730683 387.009996,385.557312 387.009996,389.876 C387.009996,390.914672 386.654666,391.775663 385.943996,392.459 Z M356.874996,378.15 C354.38765,380.336678 352.815999,383.261315 352.159996,386.924 L379.465996,386.924 C378.973994,383.261315 377.607341,380.336678 375.365996,378.15 C373.124652,375.963322 370.200014,374.87 366.591996,374.87 C362.60131,374.87 359.362342,375.963322 356.874996,378.15 Z M440.118662,368.966 C441.75867,369.840671 442.578662,370.933993 442.578662,372.246 C442.578662,372.628669 442.551329,372.901999 442.496662,373.066 C442.00466,374.815342 440.911337,375.69 439.216662,375.69 C438.943328,375.69 438.533332,375.635334 437.986662,375.526 C435.799985,375.143331 434.023336,374.952 432.656662,374.952 C428.720643,374.952 425.550008,375.853991 423.144662,377.658 C420.739317,379.462009 419.536662,381.894651 419.536662,384.956 L419.536662,408.9 C419.536662,410.212007 419.194999,411.22333 418.511662,411.934 C417.828325,412.64467 416.803336,413 415.436662,413 C414.124656,413 413.113332,412.658337 412.402662,411.975 C411.691992,411.291663 411.336662,410.266674 411.336662,408.9 L411.336662,372.246 C411.336662,370.933993 411.691992,369.92267 412.402662,369.212 C413.113332,368.50133 414.124656,368.146 415.436662,368.146 C418.170009,368.146 419.536662,369.512653 419.536662,372.246 L419.536662,373.804 C421.17667,371.890657 423.199317,370.387339 425.604662,369.294 C428.010008,368.200661 430.579315,367.654 433.312662,367.654 C436.21001,367.654 438.478654,368.091329 440.118662,368.966 Z M493.637328,368.966 C495.277336,369.840671 496.097328,370.933993 496.097328,372.246 C496.097328,372.628669 496.069995,372.901999 496.015328,373.066 C495.523326,374.815342 494.430003,375.69 492.735328,375.69 C492.461994,375.69 492.051998,375.635334 491.505328,375.526 C489.318651,375.143331 487.542002,374.952 486.175328,374.952 C482.239309,374.952 479.068674,375.853991 476.663328,377.658 C474.257983,379.462009 473.055328,381.894651 473.055328,384.956 L473.055328,408.9 C473.055328,410.212007 472.713665,411.22333 472.030328,411.934 C471.346991,412.64467 470.322002,413 468.955328,413 C467.643322,413 466.631998,412.658337 465.921328,411.975 C465.210658,411.291663 464.855328,410.266674 464.855328,408.9 L464.855328,372.246 C464.855328,370.933993 465.210658,369.92267 465.921328,369.212 C466.631998,368.50133 467.643322,368.146 468.955328,368.146 C471.688675,368.146 473.055328,369.512653 473.055328,372.246 L473.055328,373.804 C474.695336,371.890657 476.717983,370.387339 479.123328,369.294 C481.528674,368.200661 484.097981,367.654 486.831328,367.654 C489.728676,367.654 491.99732,368.091329 493.637328,368.966 Z M555.191994,371.754 C555.191994,372.300669 555.027996,372.956663 554.699994,373.722 L529.607994,430.138 C528.951991,431.832675 527.886002,432.68 526.409994,432.68 C525.863325,432.68 525.207331,432.516002 524.441994,432.188 C522.801986,431.47733 521.981994,430.41134 521.981994,428.99 C521.981994,428.333997 522.145993,427.678003 522.473994,427.022 L530.673994,408.572 L512.223994,373.558 C511.95066,373.065998 511.813994,372.492003 511.813994,371.836 C511.813994,371.12533 512.032659,370.469336 512.469994,369.868 C512.90733,369.266664 513.481324,368.802002 514.191994,368.474 C514.683997,368.255332 515.230658,368.146 515.831994,368.146 C517.362669,368.146 518.510657,368.911326 519.275994,370.442 L534.281994,400.29 L547.483994,370.524 C548.194664,368.938659 549.260654,368.146 550.681994,368.146 C551.392664,368.146 552.048658,368.282665 552.649994,368.556 C554.344669,369.212003 555.191994,370.277993 555.191994,371.754 Z"
                        id="referberry" fill="#ffffff"></path>
                    </g>
                </g>
                </g>
            </svg>
        </div>

        <div class="buttonHalf">
            <div class="buttonContainer">
                <!--<button style="position:relative" type="button" class="" @click="loginFacebook">
                  <div class="icon icon--ei-sc-facebook icon--s inputIcon fbIcon"><svg class="icon__cnt"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#ei-sc-facebook-icon"></use></svg></div>
                  Login with Facebook
                </button>-->
                <button style="position:relative" type="button" class="" @click="loginGoogle">
                  <span class="inputIcon googleIcon" data-icon="ei-sc-google-plus" data-size="s"></span>
                  Login with Google
                </button>
                <form @submit="loginEmail">
                  <div class="divider"><span>or</span></div>
                  <div style="position:relative">
                    <input class="" type="email" v-model.trim="email" placeholder="Email">
                    <div class="inputIcon rightMiddle" data-icon="ei-envelope" data-size="s"></div>
                  </div>
                  <div style="position:relative">
                    <input class="" type="password" v-model="password" placeholder="Password">
                    <span class="inputIcon rightMiddle" data-icon="ei-lock" data-size="s"></span>
                  </div>
                  <button type="submit" class="btnLoginWithEmail">Login / Sign up</button>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from './Spinner'
const Firebase = window.firebase

export default {
  name: 'Login',

  props: {
  },

  data () {
    return {
      email: '',
      password: ''
    }
  },

  created () {
  },

  watch: {

  },

  computed: {
    ...mapGetters(['isLoadingUser'])
  },

  components: {
    Spinner
  },

  methods: {
    loginFacebook () {
      // TODO
      alert('Unimplemented.')
    },

    loginGoogle () {
      let provider = new Firebase.auth.GoogleAuthProvider()
      provider.addScope('email')
      console.log('logging in w/ google')
      Firebase.auth().signInWithRedirect(provider).then((result) => {
        console.log('google logged in')
        console.log(result)
      })
    },

    loginEmail (event) {
      event.preventDefault()
      console.log(this.email, this.password)
      Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then((result) => {
        console.log(result)
      }).catch((error) => {
        if (error.code === 'auth/user-not-found') {
          // create new user
          Firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then((result) => {
            // New user created
          }).catch((error) => {
            // Error with creating non-existant user
            console.log('new user error', error)
            alert(error.message)
          })
        } else {
          // Different error with logging in, such as wrong password
          alert(error.message)
        }
      })
    }
  }
}
</script>

<style scoped>

    .container {
        display: flex;
    }

    .colorHalf {
        display: flex;
        width: 50%;
        height: 100vh;
        background: linear-gradient(132deg, #FD9999, #FED49D);
    }

    .buttonHalf {
        box-sizing: border-box;
        width: 50%;
        height: 100vh;
        background: #fbfbfb;
        padding: 6%;
        display: flex;
    }

    @media (max-width: 810px) {
      .container {
        flex-wrap: wrap;
      }
      .colorHalf {
        width: 100%;
        height: 40%;
      }
      .buttonHalf {
        width: 100%;
        height: inherit;
      }
    }

    .logo {
        position: relative;
        top: -5%;
        max-width: 40%;
        margin: auto;
        mix-blend-mode: screen;
    }

    .buttonContainer {
        margin: auto;
        width: 100%;
        font-family: 'Montserrat', sans-serif;
    }

    input, button {
        box-sizing: border-box;
        border: 2px solid #FCBE9D;
        background: none;
        outline: none;
        width: 100%;
        font-size: 15px;
        padding: 0px 25px;
        line-height: 49px;
        margin-bottom: 10px;
        color: #FCBE9D;
        border-radius: 10px;
        font-family: 'Montserrat', sans-serif;
        letter-spacing: 0.01em;
        font-weight: bold;
    }

    input:focus, button:focus {
        border: 2px solid #FD9999;
        color: #FD9999;
    }

    input:focus + .icon {
      fill: #FD9999 !important;
    }

    button:hover {
      border-color: #FD9999;
      color: #FD9999;
    }

    button:hover .icon {
      fill: #FD9999 !important;
    }

    button {
        cursor: pointer;
        box-shadow: none !important;
    }

    .divider {
        color: #FCBE9D;
        margin-bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 20px;
        font-family: 'Montserrat', sans-serif;
        letter-spacing: 0.01em;
        border-bottom: 2px solid #FCBE9D;
        position: relative;
        transform: translate(0,-50%);
    }

    .divider span {
        position: relative;
        top: 11px;
        padding: 0 10px;
        background: #fbfbfb;
    }

    .btnLoginWithEmail {
        background: #FCBE9D;
        color: #fff;
        border-color: #FCBE9D;
    }

    .btnLoginWithEmail:hover, .btnLoginWithEmail:focus {
      color: #fff;
      background: #FD9999;
      border-color: #FD9999;
    }

    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #fdb7b7;
        font-weight: 200;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: #fdb7b7;
        font-weight: 200;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: #fdb7b7;
        font-weight: 200;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: #fdb7b7;
        font-weight: 200;
    }

    :focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #FD9999;
        font-weight: 200;
    }
    :focus::-moz-placeholder { /* Firefox 19+ */
        color: #FD9999;
        font-weight: 200;
    }
    :focus:-ms-input-placeholder { /* IE 10+ */
        color: #FD9999;
        font-weight: 200;
    }
    :focus:-moz-placeholder { /* Firefox 18- */
        color: #FD9999;
        font-weight: 200;
    }

    >>> .inputIcon {
      fill: #FCBE9D;
    }

    >>> .fbIcon {
      width: 30px;
      height: 50px;
      vertical-align: bottom;
      top:-1px;
    }

    >>> .googleIcon {
      width: 30px;
      height: 50px;
      vertical-align: bottom;
      margin-right: 6px;
    }

    >>> .rightMiddle {
      position: absolute;
      right: 15px;
      top: 0px;
      height: 53px;
      width: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue